module.exports = __webpack_public_path__ + "img/img-integralManage.72c6d31e.png";